export default __webpack_public_path__ + "static/media/W_wdt_c_cap_3.0a8c47c2.mp3";